import React from 'react';
import config from '../../../utils/config';

function SalesPrediction() {
	return (
		<div id="main-container" className="main-container nav-effect-1">
			<iframe
				style={{ top: '0px' }}
				id="ouilink-iframe"
				// La query est recopiée : sans ça, un paramètre d'URL tapé dans le back-office
				// n'atteint jamais l'application v4, qui vit dans l'iframe.
				src={`${config.reportingV4Url}sales-prediction${window.location.search}`}
			/>
		</div>
	);
}
export default SalesPrediction;
